<template>
  <div class="nodata">
    <div class="nodata__img">
      <img src="@/assets/style/desktop/img/no-data.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoData'
}
</script>

<style lang="scss" scoped>

</style>
